import { gql } from 'apollo-boost'

export const UPDATE_SEND_NOTIFICATION = gql`
  mutation UpdateSendNotification($input: UpdateSendNotificationFlagInput!) {
    updateSendNotificationFlag(input: $input) {
      message
    }
  }
`
